<template>
  <div class="mx-2 my-3 text-sm flex " :class="!selfMessage ? 'justify-start' : 'justify-end'">
    <ChatMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-if="message.type == 'chat'" />
    <AudioMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'audio'" />
    <VideoMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'video'" />
    <ImageMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'image'" />
    <FileMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'document'" />
    <LocationMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'location'" />
    <PttMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'ptt'" />
    <StickerMessage :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'sticker'" />
    <VCard :self-message="selfMessage" :message="message" :conversation="conversation" :hour="setDateFormat(message?.date)" v-else-if="message.type == 'vcard'" />
  </div>
  <div ref="endDivref"></div>
</template>
<script>
import moment from "moment";
import { mapFields } from "vuex-map-fields";
import notify from "@/utils/notify";
import ChatMessage from "../widgets/ChatMessage.vue";
import AudioMessage from "../widgets/AudioMessage.vue";
import FileMessage from "../widgets/FileMessage.vue";
import LocationMessage from "../widgets/LocationMessage.vue";
import PttMessage from "../widgets/PttMessage.vue";
import VideoMessage from "../widgets/VideoMessage.vue";
import VCard from "../widgets/VCard.vue";
import ImageMessage from "../widgets/ImageMessage.vue";
import StickerMessage from "../widgets/StickerMessage.vue";
export default {
  name: "MessageMessage",
  components: {
    ChatMessage,
    AudioMessage,
    FileMessage,
    LocationMessage,
    PttMessage,
    VideoMessage,
    StickerMessage,
    VCard,
    ImageMessage
  },

  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields("conversations/show", {
      conversation: "item",
    }),
    selfMessage() {
      return this.message?.message_id?.startsWith("true");
    },
  },
  methods: {
    setDateFormat(date) {
      if (!date) return "—";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    clipboard(message) {
      try {
        navigator.clipboard.writeText(JSON.parse(message ?? ""))
        notify("Message copié ", "success")
      } catch (error) {
        alert("Impossible de copier le texte")
      }

    }
  },
  mounted() {
    this.$refs.endDivref.scrollIntoView()
  },
};
</script>
